import React from 'react';
import PropTypes from 'prop-types';

import PersonImg from 'inside-out/images/medicare/person-4.png';

import {
	innerWrapperStyle,
	wrapperStyle,
	attendStyle,
	titleStyle,
	attendTitleStyle,
	textStyle,
} from 'inside-out/page-styles/medicare';

import {
	contentSection,
} from 'inside-out/global-styles';

const MedicareForMeStep5Page = () => (
  <div className={wrapperStyle}>
    <section className={contentSection()} id="level-3">
      <div className={innerWrapperStyle}>
        <header>
          <h1 className={titleStyle}>Visit your GP</h1>
        </header>
        <div className={textStyle}>
          <p>At or before your 30th session, you will need to visit your GP for another review. At this point, the GP can approve a final course of up to 10 psychological sessions.</p>

          <p>It may seem like you need to visit your GP a lot of times during the course of treatment. However, people with eating disorders should be regularly attending a GP for medical montioring as part of treatment. So, this process can be done as part of your routine visit with your GP.</p>
        </div>
      </div>
    </section>

    <section className={contentSection('#fff')}>
      <div className={attendStyle}>
        <img src={ PersonImg } alt="" />
        <div>
          <h1 className={attendTitleStyle}>Attend Sessions 31-40</h1>
          <div className={textStyle}>
            <p>For many people up to 40 sessions of psychological treatment and 20 sessions of dietetic treatment will result in vast improvements to the eating disorder.</p>

            <p>However, if you require further treatment once your sessions under the eating disorders plan have finished, please discuss your options with your treating team.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export { MedicareForMeStep5Page }



// WEBPACK FOOTER //
// ./src/components/medicare/for-me/step-5.js